/* eslint-disable no-nested-ternary */
import React from 'react';
import Styled from './BonusBanner.style';
import { Row, Col } from 'react-styled-flexboxgrid';
import Typography from '../Typography';
import { useNavigate } from 'react-router-dom';
import { useResponsivity } from '../../helpers/helpers';
interface BonusBannerProps {
  imageUrl: string;
  title: string;
  desc: string;
  buttonPath?: string;
  buttonText?: string;
  type?: string;
  theme?: string;
  size?: string;
  bgPosition: string;
  subText?: string;
  hasOverlay?: boolean;
  paidGWF?: boolean;
}

const BonusBanner: React.FC<BonusBannerProps> = (props) => {
  const {
    imageUrl,
    title,
    desc,
    buttonPath,
    buttonText,
    theme,
    size = 'full',
    bgPosition,
    type,
    subText,
    hasOverlay,
    paidGWF,
  } = props;

  const navigate = useNavigate();
  const isMobile = useResponsivity();
  const icon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 11V17C16 17.5304 15.7893 18.0391 15.4142 18.4142C15.0391 18.7893 14.5304 19 14 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17L1 6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4L9 4M13 1L19 1M19 1V7M19 1L8 12"
        stroke="#1E2637"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <Col md={size === 'half' ? 6 : 12} xs={12} sm={12}>
      <Styled.Wrap
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(45, 44, 44, 0.5) 0%, rgba(242, 242, 242, 0) 100%),url(${imageUrl})`,
          backgroundPosition: `left top, ${bgPosition}`,
          minHeight: size === 'half' ? '310px' : '340px',
          padding: size === 'half' ? '2rem' : '3rem',
        }}
      >
        <Styled.ContentWrap
          style={
            hasOverlay
              ? {
                  background: 'rgba(0,0,0,0.2)',
                  borderRadius: '8px',
                  padding: '16px',
                }
              : null
          }
        >
          <Row>
            <Col md={size === 'half' ? 10 : 5} xs={12} sm={12}>
              <Typography
                text={title}
                size="1"
                style={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: isMobile ? '24px' : '32px',
                  marginBottom: '16px',
                  padding: isMobile ? '0rem 5rem 0rem 0rem' : '0px',
                }}
              />
            </Col>
          </Row>
          <Row>
            {' '}
            <Col md={size === 'half' ? 7 : 5} xs={12} sm={12}>
              <Typography
                size="p"
                text={desc}
                style={{
                  color: 'white',
                  marginBottom: '16px',
                  padding: isMobile ? '0rem 5rem 0rem 0rem' : '0px',
                }}
              />
            </Col>
          </Row>
          {subText && (
            <Row>
              <Col md={12} xs={12} sm={12}>
                {subText}
              </Col>
            </Row>
          )}
          <Row>
            {buttonPath && buttonText ? (
              <Col md={size === 'half' ? 6 : 5} xs={12} sm={12}>
                <Styled.ButtonNew
                  style={{
                    background: theme === 'green' ? '#20C97E' : '#fff',
                    border:
                      theme === 'green'
                        ? '1px solid #358763'
                        : '1px solid #0b2641',
                  }}
                  onClick={() => {
                    navigate(buttonPath);
                  }}
                >
                  {buttonText}{' '}
                  {theme === 'green' && (
                    <span style={{ marginLeft: '8px' }}>{icon}</span>
                  )}
                </Styled.ButtonNew>
              </Col>
            ) : null}
          </Row>
        </Styled.ContentWrap>
      </Styled.Wrap>
    </Col>
  );
};

export default BonusBanner;
